import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../utils';

export const getPricingSummary = (query) => {
  const { CustomerId } = query;

  return fetchGet(`/CustomerEnquiry/Customer/${CustomerId}/PricingSummary`, null, 'Inline')
    .then((result) => result && result.PricingSummary);
};

export const fetch = async (query: { CustomerId: number; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { CustomerId, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `/CustomerEnquiry/Customer/${CustomerId}/PricingDetails`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        PricingDetails: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.PricingDetails) {

            return {
              records: result.PricingDetails.map((item: any) => ({
                ...objectify(item, null, 'Inline'),
                Breaklevels: (item.Breaklevels || []).map((i) => objectify(i, null, 'Inline'))
              })),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
